import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import SoFormPanel from 'refactored/features/soForm/components/layout/SoFormPanel';
import SoFormRowContainer from 'refactored/features/soForm/components/layout/SoFormRowContainer';
import SoFormPanelText from 'refactored/features/soForm/components/layout/SoFormPanelText';
import {
  GirdedQuestionIcon,
  FormLoadIcon,
  FormUnloadIcon,
} from 'refactored/ui/icons';
import SoFormCollapsableInput from './SoFormCollapsableInput';
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
import { useSelector } from 'react-redux';
import { selectors as shipmentsSelectors } from 'state/shipments';
import SoHandlingTooltipDefault from './handlingTooltips/SoHandlingTooltipDefault';
import Tooltip from 'components/Tooltip';
import SoHandlingTooltipNotAllowed from './handlingTooltips/SoHandlingTooltipNotAllowed';
import SoHandlingTooltipIncluded from './handlingTooltips/SoHandlingTooltipIncluded';
import SoHandlingTooltipMixed from './handlingTooltips/SoHandlingTooltipMixed';
import { selectors as settingsSelectors } from 'state/settings';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* padding: 16px 12px 16px 16px; */
  gap: 12px;
  width: 100%;
`;

const RowLeftData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  height: 44px;
  /* border: 1px solid red; */
  width: 100%;
`;

const StopType = styled.div`
  height: 24px;

  /* 16px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 700 */

  color: #54708c;
`;
const CompanyName = styled.div`
  height: 16px;

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */
`;

const RowRightData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;
  gap: 8px;

  height: 16px;
  /* border: 1px solid red; */
  width: 100%;
`;

const RowRightText = styled.div`
  height: 16px;

  /* 14px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  text-align: right;

  /* grey / 700 */

  color: #54708c;
`;
const handlingNotAllowedForVehiclesInSpain = [
  'heavy_rigid',
  'heavy_rigid_truck',
  'trailer',
];

const SoFormHandlings = ({ className }) => {
  const { t } = useTranslation('Catalog');

  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const price_per_handling = stepsState.complements.price_per_handling;

  const { add_handling_loading, add_handling_unloading } =
    stepsState.complements;
  const redux_address_from = useSelector((state) =>
    shipmentsSelectors.getShipmentAddress(state, 'FIRST_SHIPMENT', 'pickup')
  );
  const redux_address_to = useSelector((state) =>
    shipmentsSelectors.getShipmentAddress(state, 'FIRST_SHIPMENT', 'dropoff')
  );

  const selectedProductType = stepsState.price.selectedProductType;
  const candidates = stepsState.price.candidates;
  const selectedCandidate = candidates.find(
    (c) => c.productType === selectedProductType
  );

  const quote = selectedCandidate.formData.quote;

  const quoteVehicle = quote.vehicle_type;

  const isHandlingAllowedForVehicle =
    !handlingNotAllowedForVehiclesInSpain.includes(quoteVehicle);

  const countrySettings = useSelector(settingsSelectors.getCountrySettings);

  const isSpain = countrySettings.country === 'ES';

  const isDisabledBecauseOfTransportLaw =
    !isHandlingAllowedForVehicle && isSpain;

  const loads = stepsState.configuration.loads;

  let areSomeLoadsBoxes = false;

  let areAllLoadsBoxes = true;

  loads.forEach((load) => {
    if (load.load_type === 'PARCEL') {
      areSomeLoadsBoxes = true;
    } else {
      areAllLoadsBoxes = false;
    }
  });

  const isDisabledBecauseOfLoadsAreBoxes = areAllLoadsBoxes;

  const isHandlingDisabled =
    isDisabledBecauseOfTransportLaw || isDisabledBecauseOfLoadsAreBoxes;

  let DynamicTooltip = SoHandlingTooltipDefault;

  if (isHandlingDisabled) {
    if (isDisabledBecauseOfLoadsAreBoxes)
      DynamicTooltip = SoHandlingTooltipIncluded;
    if (isDisabledBecauseOfTransportLaw)
      DynamicTooltip = SoHandlingTooltipNotAllowed;
  } else {
    if (!areAllLoadsBoxes && areSomeLoadsBoxes)
      DynamicTooltip = SoHandlingTooltipMixed;
  }

  const selectHandlingLoading = useCallback(() => {
    const newValue = !add_handling_loading;
    stepsApi.setAddHandling(newValue, 'pickup');
  }, [add_handling_loading, stepsApi]);

  const selectHandlingUnloading = useCallback(() => {
    const newValue = !add_handling_unloading;
    stepsApi.setAddHandling(newValue, 'dropoff');
  }, [add_handling_unloading, stepsApi]);

  return (
    <div className={className}>
      <SoFormPanel>
        <SoFormRowContainer>
          <SoFormPanelText>
            {t('complements.loading_unloading')}
          </SoFormPanelText>
          <Tooltip
            className="title-tooltip"
            component={<DynamicTooltip />}
            segmentTitle="form complements_handling"
          >
            <GirdedQuestionIcon />
          </Tooltip>
        </SoFormRowContainer>
        <TempContainer>
          <SoFormCollapsableInput
            isSelected={add_handling_loading}
            setIsSelected={selectHandlingLoading}
            icon={<FormLoadIcon />}
            label={t('complements.request_loading')}
            isDisabled={isHandlingDisabled}
          >
            <RowContainer>
              <RowLeftData>
                <StopType>{t('complements.in_pickup')}</StopType>
                <CompanyName>{redux_address_from.company_name}</CompanyName>
              </RowLeftData>
              <RowRightData>
                <RowRightText>
                  {price_per_handling && `+ ${price_per_handling} €`}
                </RowRightText>
              </RowRightData>
            </RowContainer>
          </SoFormCollapsableInput>
          <SoFormCollapsableInput
            isSelected={add_handling_unloading}
            setIsSelected={selectHandlingUnloading}
            icon={<FormUnloadIcon />}
            label={t('complements.request_unloading')}
            isDisabled={isHandlingDisabled}
          >
            <RowContainer>
              <RowLeftData>
                <StopType>{t('complements.in_dropoff')}</StopType>
                <CompanyName> {redux_address_to.company_name}</CompanyName>
              </RowLeftData>
              <RowRightData>
                <RowRightText>
                  {price_per_handling && `+ ${price_per_handling} €`}
                </RowRightText>
              </RowRightData>
            </RowContainer>
          </SoFormCollapsableInput>
        </TempContainer>
      </SoFormPanel>
    </div>
  );
};

SoFormHandlings.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export default styled(SoFormHandlings)`
  ${regularCSS}
`;
